import React, { useEffect, useState } from 'react';
import styles from './leaseextensionform.module.css';
import { Helmet } from 'react-helmet';
import { Background, Parallax } from "react-parallax";
import dayjs from 'dayjs';
import { Link as Linkto, useHistory } from "react-router-dom";
import axios from 'axios';

const LeaseExtensionFormExpired = ({ match, props }) => {
    const { str } = match?.params;
    const redirect = useHistory();
    const [propertyDetails, setPropertyDetails] = useState(null);

    useEffect(() => {
        const fetchByID = async () => {
            await axios.get(process.env.REACT_APP_TENANT_API_URL + 'v1/detail-by-lease-link-token/' + str).then(response => {
                const resData = response.data;
                if (resData?.property) {
                    setPropertyDetails(resData?.property);
                } else {
                    redirect.push('/lease-extension-form-invalid');
                }
            }).catch(error => {
                redirect.push('/lease-extension-form-invalid');
            });
        }
        fetchByID();
    }, [str, redirect]);

    return (<React.Fragment>
        <Helmet title="Lease Extension Form Expired" />

        <Parallax strength={300} className="RentalParallax">
            <Background className="custom-bg">
                <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
            </Background>
        </Parallax>

        <div className="WhiteBG">

            <div className={`${styles.RentalAppliArea}`}>

                <div className={`${styles.RescheduleMessageSec}`}>
                    <img src="/static/img/reschedule-cancel.png" alt="" />
                    <p className={`${styles.MessageTitle}`}>Expired Link</p>
                    <p className={`${styles.MessageText}`}>This lease extension link has expired.</p>
                </div>


            </div>

            <div className={`${styles.FooterWrap}`}>
                <div className={`${styles.footerMain}`}>

                    <div className={`${styles.footerMainLeft}`}>
                        <Linkto to={'/'}><img src={'/static/img/logo.svg'} alt="logo" /></Linkto>
                    </div>

                    <div className={`${styles.footerMainRight}`}>
                        <div>
                            <h3>CONTACT US</h3>
                            <ul>
                                <li><a href={`mailto: ${propertyDetails?.email}`}>{propertyDetails?.email}</a></li>
                                <li><a href={`tel: ${propertyDetails?.phone}`} >{propertyDetails?.phone}</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>FIND US</h3>
                            <ul>
                                <li>{propertyDetails?.address} <br />{propertyDetails?.city}, {propertyDetails?.state} {propertyDetails?.zip}</li>
                            </ul>
                        </div>
                        <div>
                            <h3>LEGAL</h3>
                            <ul>
                                <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li>PropertyDek © {dayjs().format("YYYY")}.<br />All rights reserved.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </React.Fragment>)
}

export default LeaseExtensionFormExpired;